import type { AutofillItem } from "./types";

export const review: AutofillItem[] = [
  {
    keyword: "プロフェッショナリズム",
    contents: [
      "迅速かつ的確な対応に感謝します。",
      "常に高品質な仕事を提供してくれます。",
      "プロフェッショナルな対応が際立っています。",
      "期待を超える成果をいつもありがとうございます。",
      "プロジェクトがスムーズに進行しました。",
    ],
  },
  {
    keyword: "創造性",
    contents: [
      "独創的なアイデアに驚かされました。",
      "創造力豊かなアプローチが素晴らしいです。",
      "斬新な視点でプロジェクトを進めてくれます。",
      "予想以上のクリエイティブな成果に感謝します。",
      "独自の視点と技術により、プロジェクトが一層引き立ちました。",
    ],
  },
  {
    keyword: "オリジナリティ",
    contents: [
      "独自性あふれる仕事に感動しました。",
      "他にはないオリジナルなアイデアを提供してくれます。",
      "唯一無二のアプローチが魅力的です。",
      "常にオリジナルな視点での提案が素晴らしいです。",
      "独自のスタイルがプロジェクトに新しい風を吹き込みました。",
    ],
  },
  {
    keyword: "新規性",
    contents: [
      "斬新なアイデアが光ります。",
      "新しい視点でプロジェクトを進めてくれました。",
      "革新的な提案に感謝します。",
      "常に最新のアプローチを提供してくれます。",
      "プロジェクトに新しい息吹を与えてくれます。",
    ],
  },
  {
    keyword: "納期遵守",
    contents: [
      "いつも納期を守ってくれます。",
      "時間厳守で信頼できます。",
      "納期内に高品質な成果を提供してくれます。",
      "スケジュール通りに進行してくれました。",
    ],
  },
  {
    keyword: "技術",
    contents: [
      "卓越した技術力に感謝します。",
      "高い技術力を持ち、常に最先端の方法を取り入れています。",
      "技術力の高さに驚かされました。",
      "プロフェッショナルな技術力を提供してくれます。",
      "技術的な課題に迅速に対応してくれます。",
    ],
  },
  {
    keyword: "安定性",
    contents: [
      "常に安定した成果を提供してくれます。",
      "安定したクオリティに感謝します。",
      "安定したパフォーマンスに感謝します。",
    ],
  },
  {
    keyword: "柔軟さ",
    contents: [
      "柔軟な対応に感謝します。",
      "プロジェクトの変化に柔軟に対応してくれます。",
      "柔軟なアプローチで問題を解決してくれます。",
      "状況に応じた柔軟な対応に感謝します。",
    ],
  },
  {
    keyword: "モチベーション",
    contents: [
      "常に高いモチベーションを持って取り組んでくれます。",
      "モチベーションが高く、エネルギッシュに仕事を進めてくれます。",
    ],
  },
  {
    keyword: "コミュニケーション",
    contents: [
      "優れたコミュニケーション能力でプロジェクトを円滑に進めてくれます。",
      "コミュニケーションがスムーズで、迅速な対応に感謝します。",
      "明確で効果的なコミュニケーションがプロジェクトを成功に導いてくれました。",
      "優れたコミュニケーションスキルで問題を迅速に解決してくれます。",
      "コミュニケーションが円滑で、常に迅速な対応をしてくれます。",
    ],
  },
  {
    keyword: "チームワーク",
    contents: [
      "チームワークが素晴らしく、プロジェクトがスムーズに進行しました。",
      "チーム全体が協力し合い、目標を達成することができました。",
      "協力的な姿勢でチームワークを発揮し、プロジェクトを成功に導いてくれました。",
      "チームメンバーとのコミュニケーションが円滑で、成果を最大化できました。",
      "チームワークが抜群で、プロジェクトが期待以上に進行しました。",
    ],
  },
  {
    keyword: "暗黙知",
    contents: [
      "深い理解と暗黙知の共有がプロジェクトの成功に寄与しました。",
      "経験に基づく暗黙知がプロジェクトの進行に役立ちました。",
      "暗黙知を活かした対応が素晴らしいです。",
      "豊富な経験と暗黙知の共有でプロジェクトがスムーズに進行しました。",
      "暗黙知を活用した迅速な対応に感謝します。",
    ],
  },
  {
    keyword: "目的の理解",
    contents: [
      "プロジェクトの目的を深く理解し、それに沿った提案をしてくれます。",
      "目的をしっかり理解し、それに基づいた適切な対応に感謝します。",
    ],
  },
  {
    keyword: "提案力",
    contents: [
      "常に的確で実現可能な提案をしてくれます。プロジェクトの進行に大いに役立ちました。",
      "効果的な提案がプロジェクトの成功に寄与しました。ありがとうございます。",
      "優れた提案力でプロジェクトを進めてくれます。",
      "提案力が高く、プロジェクトの進行をスムーズにしてくれます。",
      "具体的で実行可能な提案がプロジェクトの成功に大きく貢献しました。",
    ],
  },
];
